let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9FkeH")).then(() => parcelRequire('3ve62'));